import {commentType} from "@/utils/commentType";
import {getCategory1ListApi, getCategoryListApi, getCategoryListByTopicApi, getCategoryListByTopicNoSelectApi, getOtherByTopicIdNotSelectedApi} from "@/api/admin/categoryApi";
import {
    getListTopicApi,
    getListTopicCountApi,
    pushAllSelGoodsApi,
    updateGoodsPriceApi,
    getTopicListApi,
    updateSortApi,
    loadSimilarProductsApi,
    batchSaveProductsApi,
    getTopicTagsListApi, saveTopicTagApi
} from "@/api/admin/topicApi";
import ObjectUtil from "@/utils/ObjectUtil";
import SelGoods from "@/views/SelectGoods/components/SelGoods/index.vue";
import JdAddressListDelivery from "@/components/JdAddressListDelivery/index.vue";
import {editDisPriceApi} from "@/api/backend/goodsManageApi.js";
import {deleteGoodsLowestBuyApi, updateMasterJdDataStatus} from "@/api/admin/goodsApi";
// import {findBackendJdRegionApi} from "@/api/backend/addressApi";

/**
 * 选品商品
 */
export const mixins = {
    name: "Goods",
    /*watch: {
        'selectionGoods.categoryId1Name': {
            handler(newVal, oldVal) {
                // 防止初始设置时重复调用
                if (newVal !== oldVal && newVal !== null && newVal !== undefined) {
                    this.getCategory1List();
                }
            },
            // 立即执行一次，处理初始值
            immediate: true
        }
    },*/
    data: function () {
        return {
            parentDialogVisible: false,
            selectedAddresses: JSON.parse(localStorage.getItem('selectedAddresses')) || {},
            dialog: false,
            item: {},
            firstPage: true,
            index: 0,
            selectionGoods: {
                status: 1,
                topicId: "",
                commentType: "",
                goodsId: "",
                current: 1,
                size: 10,
                total: 999,
                isJd: 1,
                title: "",
                categoryId1Name: "",
                categoryId2Name: "",
                categoryId3Name: "",
                level: "",
                phone: "",
                minSupplyPrice: "",
                maxSupplyPrice: "",
                minProfitMargin: "",
                maxProfitMargin: "",
                priceSort: "",
                keywords: "",
                commentOkCount: "",
                logisticsType: "",
                addressMapList: {}
            },
            markUpVisible: false,
            selectionGoodsDto: {
                rate: 1.25,
                systemRate: 0.800,
                disPrice: 0,
                disPriceType: 1,
                type: "",
                item: ""
            },
            systemRate: 0.800,
            categoryId1: [],
            categoryId2: [],
            categoryId3: [],
            selectGoods: [],
            total: 999,
            loading: false,
            rate: 1.25,
            jdRate: 1,

            topicVisible: false,
            topicListVo: [],
            topicListDto: [],
            chooseTopicId: '', // 选择当前选品库的Id为
            topicDto: {},
            childData: {},     // 存储所有子表格数据，结构：{ 父id: [子数据1, 子数据2] }
            idArr: [],
            moveTopicId: "",
            moreConditions: true,
            tagVisible: false,
            tagListVo: [],
            tagDo: {
                id: '',
                topicId: '',
                categoryId1: '',
                categoryId2: '',
                categoryId3: '',
                categoryName1: '',
                categoryName2: '',
                categoryName3: '',
                staffId: '',
                logisticsType: '',
                commentOkCount: '',
                skuName: '',
                tagName: '',
                minProfitMargin: '',
                maxProfitMargin: ''
            },
            tagSelectDto: {
            },
        };
    },
    components: {SelGoods, JdAddressListDelivery},
    methods: {
        async tagDataPopulateSearch(tagItem) {
            this.chooseTopicId = tagItem.topicId
            if (tagItem.skuName) {
                this.selectionGoods.title = tagItem.skuName;
            }
            if (tagItem.categoryId1) {
                this.selectionGoods.categoryId1Name = tagItem.categoryId1;
            }
            if (tagItem.categoryId2) {
                this.selectionGoods.categoryId2Name = tagItem.categoryId2;
            }
            if (tagItem.categoryId3) {
                this.selectionGoods.categoryId3Name = tagItem.categoryId3;
            }
            if (tagItem.commentOkCount) {
                this.selectionGoods.commentOkCount = tagItem.commentOkCount;
            }
            if (tagItem.minProfitMargin) {
                this.selectionGoods.minProfitMargin = tagItem.minProfitMargin;
            }
            if (tagItem.maxProfitMargin) {
                this.selectionGoods.maxProfitMargin = tagItem.maxProfitMargin;
            }
            if (tagItem.logisticsType) {
                this.selectionGoods.logisticsType = tagItem.logisticsType;
            }
            this.index = 0;
            this.selectionGoods.current = 1;
            if (tagItem.topicId) {
                this.item = this.topicListVo.find(item => item.id === tagItem.topicId) ?? null;
                this.selectionGoods.topicId = tagItem.topicId;
                this.tagSelectDto.topicId = tagItem.topicId;
            }
            await this.initCategory(this.item.id);
            await this.getTopicTagList();
            this.queryGetList()
            // await this.updateTopicItem()
        },
        /*handleTagTopicIdChange() {
            const changeTopic = this.topicListVo.find(item => item.id === this.tagDo.topicId);
            if (!this.tagDo.tagName) {
                this.tagDo.tagName = changeTopic.title;
            }
        },*/
        closeTagVisible() {
            this.tagVisible = false;
            this.tagDo = {
                id: '',
                topicId: '',
                categoryId1: '',
                categoryId2: '',
                categoryId3: '',
                categoryName1: '',
                categoryName2: '',
                categoryName3: '',
                staffId: '',
                logisticsType: '',
                commentOkCount: '',
                skuName: '',
                tagName: '',
                minProfitMargi: '',
                maxProfitMargi: ''
            }

        },
         addTags(steps) {
            //  打开弹窗
            if (steps && steps === 1) {
                this.tagVisible = true;
                if (this.topicListVo.length < 1) {
                    this.getListTopic();
                }
                // this.getTopicTagList();
                this.initCategory();
                return;
            }
            this.$confirm('确定要添加标签吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (this.tagDo.categoryId1) {
                    this.tagDo.categoryName1 = this.categoryId1.find(item => item.categoryId === this.tagDo.categoryId1).fullName;
                }
                if (this.tagDo.categoryId2) {
                    this.tagDo.categoryName2 = this.categoryId2.find(item => item.categoryId === this.tagDo.categoryId2).fullName;
                }
                if (this.tagDo.categoryId3) {
                    this.tagDo.categoryName3 = this.categoryId3.find(item => item.categoryId === this.tagDo.categoryId3).fullName;
                }
                const res = await saveTopicTagApi(this.tagDo);
                if (res.msg === "success") {
                    this.$message.success('添加成功')
                } else {
                    this.$message({
                        type: 'success',
                        message: '添加失败!'
                    });
                }
                this.closeTagVisible();
                await this.getTopicTagList();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消添加'
                });
            });

        },
        async getTopicTagList() {
            let {data} = await getTopicTagsListApi(this.tagSelectDto);
            this.tagListVo = data;
        },
        async updateTopicItem() {
            this.index = 0;
            this.selectionGoods.current = 1;
            if (this.chooseTopicId) {
                this.item = this.topicListVo.find(item => item.id === this.chooseTopicId) ?? null;
                this.selectionGoods.topicId = this.item.id;
                this.selectionGoods.categoryId1Name = "";
                this.selectionGoods.categoryId2Name = "";
                await this.initCategory(this.item.id);
                this.tagSelectDto.topicId = this.item.id;
                await this.getTopicTagList();
            } else {
                this.item = {};
                this.selectionGoods.topicId = '';
                this.selectionGoods.categoryId1Name = "";
                this.selectionGoods.categoryId2Name = "";
                await this.initCategory();
            }
            this.queryGetList()
        },
        /**
         * 获取选择商品ID
         * @param val
         */
        handleSelectionChange(val) {
            this.idArr = val
        },
        async addNewProductOfChoice() {
            let topicId = this.item.id
            let dtoList = this.idArr.map(item => {
                return {
                    ...item,
                    goodsId: item.id
                };
            });
            let data = {
                dtoList,
                topicId
            }
            this.$confirm('此操作将新增商品到指定的选品库，是否确认继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await batchSaveProductsApi(data);
                if (res.msg === "success") {
                    this.$message.success('添加成功')
                } else {
                    this.$message({
                        type: 'success',
                        message: '添加失败!'
                    });
                }
                this.queryGetList();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消添加'
                });
            });
        },

        async loadSimilarProducts(item, expend) {
            if (expend) {
                try {
                    // 避免重复加载
                    if (this.childData[item.id]?.data) return;

                    // 显示加载状态
                    this.$set(this.childData, item.id, {
                        loading: true,
                        data: []
                    });
                    // 正确调用API方法
                    const response = await loadSimilarProductsApi(item);
                    let apiData = []
                    // 正确提取数据数组
                    if (response.data) {
                        apiData = response.data;
                    }
                    // 确保获取数组数据
                    console.log(apiData)
                    this.$set(this.childData, item.id, {
                        loading: false,
                        data: apiData.map(child => ({
                            ...child,
                            _level: (item._level || 0) + 1 // 添加层级标记
                        }))
                    });
                } catch (error) {
                    this.$set(this.childData, item.id, {
                        loading: false,
                        data: []
                    });
                    this.$message.error('加载失败');
                }
            }
        },
        openSearchTab(item) {
            let searchKeyword;
            if (item.searchKeyword) {
                searchKeyword = item.searchKeyword
            } else {
                searchKeyword = item.title.substring(0, item.title.length / 2)
            }
            // let title = item.title.substring(0,item.title.length / 2)
            // 打开新的搜索标签页
            window.open(
                `https://search.jd.com/Search?keyword=${encodeURIComponent(searchKeyword)}`,
                '_blank'
            );
            // window.open(
            //     `https://apollo-evaluate.jd.com/?jdreactkey=JDReactEvaluateModule&jdreactapp=JDReactEvaluateModule&page=EvaluateListWrapper&sku=${encodeURIComponent(item.skuId)}&showSkuChange=true&isCurrentSku=true&selectBorderColor=%23FF4500&selectBackgroundColor=%23FF4500&borderColor=%23F5FFFA&backgroundColor=#F5FFFA&hiddenH5Nav=1`,
            //     '_blank'
            // );
        },
        async kfc(item) {
            if (item) {
                this.loading = true;
                item.status = 1;
                await updateMasterJdDataStatus(item);
                this.loading = false;
            }
        },
        showAddressDialog() {
            // 使用nextTick确保父弹窗完全打开
            this.$nextTick(() => {
                this.$refs.jdAddressListDelivery.openDialog();
            });
        },
        handleAddressUpdate(newAddresses) {
            this.selectedAddresses = newAddresses;
            this.selectionGoods.addressMapList = this.selectedAddresses;
            this.getList(); // 直接触发列表刷新
        },
        closeTopicVisible() {
            this.topicVisible = false
            this.topicListVo = []
            this.topicListDto = []
        },
        /**
         * 查询选品库
         */
        async getListTopic() {
            let {data} = await getTopicListApi(this.topicDto);
            this.topicListVo = data;
        },
        async editDisPrice(item) {
            let skuIdList = item;
            if (this.selectGoods) {
                skuIdList = this.selectGoods.map(item => item.skuId);
            }
            let requestData = {
                "skuIdList": skuIdList
            };
            // await editDisPriceApi({skuId: item.skuId});
            await editDisPriceApi(requestData);
            this.getList();
        },
        tableRowClassName({row}) {
            if (row.deliveryStatus) {
                const hasError = Object.values(row.deliveryStatus).some(
                    status => !status.canPurchase
                );
                return hasError ? 'warning-row' : '';
            }
            if (row.status == 2) {
                return 'warning-row';
            }
            if (((Number(row.supplPrice) * Number(this.rate)) > Number(row.price) * Number(this.jdRate)) || (Number(row.supplPrice) >= Number(row.price) * Number(this.jdRate))) {
                return 'success-row';
            }

            if (((Number(row.supplPrice) * Number(this.rate)) > Number(row.price)) || (Number(row.supplPrice) >= Number(row.price))) {
                return 'warning-row';
            }
        },
        //  修改价格
        editRate(item) {
            if (item && item === 2) {
                if (this.rate) {
                    this.rate = Number(this.rate);
                    // this.getList();
                    this.systemRate = (this.selectGoods[0].supplPrice / (this.selectGoods[0].supplPrice * this.rate)).toFixed(3);
                    return;
                }
            }
            if (this.rate) {
                this.rate = Number(this.rate);
                // this.getList();
                this.systemRate = (this.selectGoods[0].supplPrice / (this.selectGoods[0].supplPrice * this.rate)).toFixed(3);
                return;
            }
            if (this.jdRate) {
                this.jdRate = Number(this.jdRate);
                // this.getList();
                this.systemRate = (this.selectGoods[0].supplPrice / (this.selectGoods[0].supplPrice * this.rate)).toFixed(3);
            }
        },
        /**
         * 真一键挑选
         */
        selTopicPushGoodsAll() {
            let obj = JSON.parse(JSON.stringify(this.selectionGoods));
            obj.minProfitMargin = obj.minProfitMargin / 100;
            obj.maxProfitMargin = obj.maxProfitMargin / 100;
            if (this.item.keywords) {
                obj.keywords = this.item.keywords.trim().split(/\s+/);
            }
            this.loading = true;
            ObjectUtil.removeEmptyValues(obj)
            this.$prompt('请输入加价比例', '加价比例', {
                confirmButtonText: '挑选',
                cancelButtonText: '取消',
                inputValue: 0
            }).then(async ({value}) => {
                obj.disPrice = value;
                console.log(obj)
                let {data} = await pushAllSelGoodsApi(obj);
                this.loading = false
                this.queryGetList();
                this.$message({
                    message: '一键挑选成功',
                    type: 'success'
                });
            }).catch(r => {
                this.loading = false;
            });
        },
        /**
         * 一键挑选
         */
        async selTopicCurrentGoodsAll() {
            for (const item of this.selectGoods) {
                item.disPriceType = 1;
                item.disPrice = 0;
                item.goodsId = item.id;
                item.topicId = this.item.id
                await updateGoodsPriceApi(item)
            }
            this.$message({
                message: '挑选成功',
                type: 'success'
            });
            this.queryGetList();
        },
        /**
         * 切换列表
         */
        switchGoods(index) {
            this.index = index;
            if (index == 0) {
                this.queryGetList();
            }
        },
        /**
         * 分页大小切换时触发
         * @param val
         */
        handleSizeChange(val) {
            this.selectionGoods.size = val;
            this.getList();
        },
        /**
         * 页码切换时触发
         * @param val
         */
        handleCurrentChange(val) {
            this.selectionGoods.current = val;
            this.getList();
        },
        /**
         * 评论类型
         */
        commentType() {
            return commentType
        },
        /**
         * 条件查询
         */
        queryGetList(steps, isJd) {
            this.firstPage = true;
            this.getList(steps,isJd)
        },
        /**
         * 挑选商品
         */ async setTopicCurrentGoodsId(item, type) {
            /*this.$confirm('是否开启保存点？', {
                 distinguishCancelAndClose: true,
                 confirmButtonText: '是',
                 cancelButtonText: '否', //相当于 取消按钮
                 type: 'warning'
             }).then(() => {
                 log
             }).catch(action => {
             //判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
                 if (action === 'cancel'){
                     log
                 }
             })*/
            this.selectionGoodsDto.item = item;
            this.selectionGoodsDto.type = type;
            this.markUpVisible = true;
        },
        async addGoodsInSelectionTopicGoodsRelation(item, type) {
            if (type === 1) {
                item.topicId = this.item.id;
                item.topicIds = null;
            } else if (type === 2) {
                //  topicIdList 有值就查询 没值只是打开弹窗
                if (this.topicListVo.length <= 0 || this.topicListDto.length <= 0) {
                    // 选到多个选品库
                    this.topicVisible = true;
                    await this.getListTopic();
                    this.topicVo = item;
                    return;
                }
                item.topicIds = this.topicListDto;
                item.topicId = null;
            } else {
                this.$message({
                    message: '请先选择商品',
                    type: 'warning'
                });
                this.topicListDto = [];
                this.topicListVo = [];
                return;
            }
            if (this.selectionGoodsDto.disPrice && this.selectionGoodsDto.disPrice !== 0) {
                item.disPrice = this.selectionGoodsDto.disPrice;
                console.log(1 + ' ' + item.disPrice)
            } else {
                item.disPrice = 0;
                console.log(2 + ' ' + item.disPrice)
            }
            item.disPriceType = 1;
            item.goodsId = item.id;
            console.log( item)
            // return;
            await updateGoodsPriceApi(item)
            this.queryGetList();
            if (type === 2) {
                this.topicVisible = false;
            }
            this.markUpVisible = false;
            this.topicListDto = [];
            this.topicListVo = [];
        },
        /**
         * 查询
         */
        async getList(step, isJd) {
            this.loading = true;
            if (isJd) {
                this.selectionGoods.isJd = isJd;
            }
            let obj = JSON.parse(JSON.stringify(this.selectionGoods));
            if (obj.maxProfitMargin) {
                obj.maxProfitMargin = obj.maxProfitMargin / 100;
            }
            if (obj.minProfitMargin) {
                obj.minProfitMargin = obj.minProfitMargin / 100;
            }
            if (this.item.keywords) {
                obj.keywords = this.item.keywords.trim().split(/\s+/).join(",");
            }
            ObjectUtil.removeEmptyValues(obj)
            let {data} = await getListTopicApi(obj)
            this.selectGoods = data.rows;
            this.loading = false;
            if (this.firstPage) {
                let {data} = await getListTopicCountApi(obj)
                this.total = data[0]
            }
            this.firstPage = false;
        },
        /**
         * 初始化组件
         */
        async open(item) {
            this.index = 0;
            this.selectionGoods.current = 1;
            this.dialog = true;
            this.moreConditions = true;
            if (item) {
                this.item = item;
                this.selectionGoods.topicId = item.id;
                this.selectionGoods.categoryId1Name = "";
                this.selectionGoods.categoryId2Name = "";
                await this.initCategory(item.id);
                this.chooseTopicId = item.id;
                this.tagSelectDto.topicId = this.item.id;
            } else {
                this.item = {};
                this.chooseTopicId = ''
                this.selectionGoods.topicId = '';
                this.selectionGoods.categoryId1Name = "";
                this.selectionGoods.categoryId2Name = "";
                await this.initCategory();
            }
            this.queryGetList()
            this.getListTopic()
            this.getTopicTagList()
        },
        /**
         * 初始化分类
         */
        async initCategory(temp) {
            if (temp) {
                let {data} = await getCategoryListByTopicNoSelectApi({topicId: temp});
                this.categoryId1 = data.categoryList;
                // 确保数组非空再取第一个元素
                if (this.categoryId1 && this.categoryId1.length > 0) {
                    this.selectionGoods.categoryId1Name = this.categoryId1[0].categoryId;
                    await this.getCategory1List(1);
                }
            } else {
                // let {data} = await getCategoryListByTopicApi();
                let {data} = await getCategoryListByTopicNoSelectApi();
                this.categoryId1 = data.categoryList;
            }
        },
        /**
         * 获取二级分类
         */
        async getCategory1List(categoryLevel) {
            if (this.item?.id) {
                let name = 0;
                if (categoryLevel === 1 && this.selectionGoods.categoryId1Name) {
                    name = this.selectionGoods.categoryId1Name;
                } else if (categoryLevel === 2 && this.selectionGoods.categoryId2Name) {
                    name = this.selectionGoods.categoryId2Name;
                }
                let {data} = await getOtherByTopicIdNotSelectedApi({
                    name: name, categoryLevel: categoryLevel, topicId: this.item.id
                });
                if (data && categoryLevel === 1) {
                    this.selectionGoods.categoryId2Name = ""
                    this.categoryId2 = data.categoryList;
                } else if (data && categoryLevel === 2) {
                    this.selectionGoods.categoryId3Name = ""
                    this.categoryId3 = data.categoryList;
                }
            } else {
                let name = "";
                if (categoryLevel === 1) {
                    name = this.selectionGoods.categoryId1Name;
                } else if (categoryLevel === 2) {
                    name = this.selectionGoods.categoryId2Name;
                }
                let {data} = await getOtherByTopicIdNotSelectedApi({
                    name: name, categoryLevel: categoryLevel
                });
                if (data && categoryLevel === 1) {
                    this.selectionGoods.categoryId2Name = ""
                    this.categoryId2 = data.categoryList;
                } else if (data && categoryLevel === 2) {
                    this.selectionGoods.categoryId3Name = ""
                    this.categoryId3 = data.categoryList;
                }
            }
            // this.queryGetList()
        },
        async getOtherCategoryNoTopicList(categoryLevel) {
            let name = "";
            if (categoryLevel === 1) {
                name = this.selectionGoods.categoryId1Name?.categoryId1Name ?? this.tagDo.categoryId1;
            } else if (categoryLevel === 2) {
                name = this.selectionGoods.categoryId2Name?.categoryId2Name ?? this.tagDo.categoryId2;
            }
            let {data} = await getOtherByTopicIdNotSelectedApi({
                name: name, // 分类Id
                categoryLevel: categoryLevel
            });
            if (data && categoryLevel === 1) {
                /*this.selectionGoods.categoryId2Name = ""
                this.tagDo.categoryId2 = "";*/
                this.categoryId2 = data.categoryList;
            } else if (data && categoryLevel === 2) {
                /*this.selectionGoods.categoryId3Name = ""*/
                this.categoryId3 = data.categoryList;
            }
        },
        /**
         * 切换商品货源
         */
        isJdChange() {
            this.selectionGoods.current = 1;
            this.queryGetList()
        },
        /**
         * 关闭弹窗事件
         */
        closeChange() {
            this.$emit("closeChange");
        },
        /**
         * 重置
         */
        reset() {
            this.selectionGoods = {
                topicId: this.selectionGoods.topicId,
                commentType: "",
                goodsId: "",
                current: 1,
                size: 10,
                total: 999,
                isJd: 1,
                title: "",
                categoryId1Name: "",
                categoryId2Name: "",
                level: "",
                phone: "",
                minSupplyPrice: "",
                maxSupplyPrice: "",
                minProfitMargin: "",
                maxProfitMargin: "",
                chooseTopicId: '',
            }
            this.queryGetList();
        }
    },
    mounted() {

    }
}